import { SpineIcon } from "@/components/icons/Icon";
import { getOperatingSpine } from "@/content";
import "./OperatingSpine.css";

export function OperatingSpine() {
  const spine = getOperatingSpine();

  return (
    <section className="operating-spine ivory-glass" aria-label="Earth 3.0 operating spine">
      <div className="spine-heading">
        <p className="spine-kicker">Operating spine</p>
        <p className="spine-deck">
          A continuous cycle that holds the crossing and compounds capability over time.
        </p>
      </div>

      <ol className="spine-track">
        {spine.map((step, index) => (
          <li className="spine-item" key={step.key}>
            <div
              className={[
                "spine-medallion",
                "sea-glass-fill",
                step.key === "choose" ? "is-jewel" : "",
              ].join(" ")}
              aria-hidden="true"
            >
              <span className="spine-medallion-etch" />
              <SpineIcon label={step.label} size={26} />
            </div>
            <div className="spine-copy">
              <b>{step.label}</b>
              <span>{step.text}</span>
            </div>
            {index < spine.length - 1 ? (
              <span className="spine-arrow" aria-hidden="true">
                →
              </span>
            ) : null}
          </li>
        ))}
      </ol>
    </section>
  );
}
